/**
 * Helper function to pass to Array.find, returns object that matches passed in guid
 */
export const byGuid = (guid) => (object) => object.guid === guid
